import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0eff0044"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "my-3 p-3 bg-app position-relative" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "fz-sm-34 fz-md-52 ms-3 fw-bold nunito position-absolute" }, " Make a Calendar ", -1));
const _hoisted_3 = { class: "text-white d-flex align-items-center justify-content-end mb-3" };
const _hoisted_4 = { style: { "max-width": "926px", "margin": "4rem auto" } };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "text-decoration-underline text-primary cursor-pointer" }, " this link ", -1));
const _hoisted_6 = /*#__PURE__*/ _createStaticVNode("<p style=\"color:gray;\" class=\"fz-14 nunito d-flex justify-content-center\" data-v-0eff0044><i class=\"bi bi-check fz-16\" data-v-0eff0044></i> Congrats! Your Calendar is Ready </p><p class=\"fz-20\" data-v-0eff0044>If you like our calendars, you can support me on Buy Me a Coffee. Your help will enable me to focus on creating more calendar templates and exciting features and customization options for our users.</p><div class=\"fz-32 nunito fw-bold text-center\" data-v-0eff0044><a class=\"nunito btn btn-primary text-white mt-md-3 p-2 fz-30 w-md-50 fw-bold\" target=\"_blank\" href=\"https://buymeacoffee.com/customcalendarmaker\" data-v-0eff0044>☕ <span class=\"ms-2\" data-v-0eff0044>Buy me a coffee</span></a></div>", 3);
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "d-flex flex-column flex-md-row justify-content-center mt-0" }, null, -1));
import { useRouter, useRoute } from 'vue-router';
import { useCalendarSettingsStore } from '../stores/calendarSettings';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DownloadDialog',
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const calendarSettingsStore = useCalendarSettingsStore();
        function downloadCalendar() {
            if (calendarSettingsStore.calendarCanvas != null) {
                calendarSettingsStore.saveImage(calendarSettingsStore.calendarCanvas.toDataURL(), 'calendar');
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "btn-close text-primary ms-2 me-1",
                        "aria-label": "Close",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).back()))
                    })
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("p", {
                        class: "fz-28 mb-0 mt-5 text-center",
                        "data-umami-event": "make-calendar",
                        onClick: _cache[1] || (_cache[1] = ($event) => (downloadCalendar()))
                    }, [
                        _createTextVNode(" Click "),
                        _hoisted_5,
                        _createTextVNode(" to download your calendar ")
                    ]),
                    _hoisted_6
                ]),
                _hoisted_9
            ]));
        };
    }
});
